import { useTheme } from '../../theme/ThemeContext';
export const useButtonStyles = ({
  isDisabled,
  fullWidth
}) => {
  const theme = useTheme();
  const baseStyle = {
    display: fullWidth ? 'flex' : 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    width: fullWidth ? '100%' : undefined,
    boxSizing: fullWidth ? 'border-box' : undefined,
    padding: '8px 16px',
    borderRadius: theme.components.button.borderRadius,
    border: 'none',
    cursor: isDisabled ? 'default' : 'pointer',
    fontSize: theme.fontSizes.lg,
    fontWeight: theme.fontWeights.bold,
    transition: 'background-color 0.15s, color 0.15s, border-color 0.15s',
    pointerEvents: isDisabled ? 'none' : 'auto'
  };
  const styleMap = {
    primary: {
      backgroundColor: isDisabled ? theme.colors.buttonDisabledBackground : theme.colors.primary,
      color: theme.colors.background
    },
    secondary: {
      backgroundColor: 'transparent',
      color: isDisabled ? theme.colors.textDisabled : theme.colors.primary,
      border: `1px solid ${isDisabled ? theme.colors.textDisabled : theme.colors.primary}`
    },
    danger: {
      backgroundColor: isDisabled ? theme.colors.buttonDisabledBackground : theme.colors.danger,
      color: theme.colors.background
    },
    link: {
      backgroundColor: 'transparent',
      border: 'none',
      color: theme.colors.primary,
      padding: '0',
      fontWeight: 'normal'
    }
  };
  return {
    baseStyle,
    styleMap
  };
};